module.exports = __webpack_public_path__ + "img/implante.cb24009b.png";